import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-52" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px",
      paddingBottom: "14px"
    }} data-id="element-53" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-black text-white" data-id="element-54" data-mp="32lrmhejrmzki">
          SIGMA SMART<span className="align-super text-xs" data-id="element-55" data-mp="36pz9966ny5g3">™</span> — 100+ AI PROMPTS FOR CORRECTIONS OFFICERS<span className="align-super text-xs" data-id="element-56" data-mp="3ugbqj7nstejc">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-57" data-mp="398zqhbvha9n">
          “Finish the report. Go home on time.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-58" data-mp="3le2jwsvni5b8">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-59" data-mp="3qfjey7rgexjw">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-60" data-mp="2ezbf4e3eq0bx" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-61" data-mp="3lalgfg6ys7uh">
            <InstagramIcon className="h-4 w-4 text-blush" data-id="element-62" data-mp="3gca6z6kkzzcs" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-63" data-mp="3v91b1t579z8q">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-64" data-mp="3q7bxa5qlf7gy">
            Terms & Conditions
          </a>
          <span data-id="element-65" data-mp="3473nkkfm3xo">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-66" data-mp="34p6x15ihif3">
            Privacy Policy
          </a>
          <span data-id="element-67" data-mp="hs1xj4a6eecc">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="huo4p2t5mru1">
            Support
          </a>
        </div>

        <p className="mt-6 text-[11px] leading-relaxed text-white/45" data-id="element-69" data-mp="qtrpqcbvthb6">
          This toolkit helps you organize your own facts. It does not replace your agency’s policies, training or legal advice.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-70" data-mp="tt09erhmoor0">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}